import React from 'react'

const TodoItem = ({todo,onToggleTodo,onDeleteTodo}) => {
  return (
   <li className="todo-item">
      <input
        type="checkbox"
        checked={todo.completed}
        onChange={() => onToggleTodo(todo.id)}
      />

      <span className={todo.completed ? "todo-text completed" : "todo-text"}>
        {todo.text}
      </span>

      <button className="delete-button" type="button" onClick={() =>onDeleteTodo(todo.id)}>
        ×
      </button>
    </li>
  )
}

export default TodoItem